import { render, staticRenderFns } from "./DlvD.vue?vue&type=template&id=79f59398"
import script from "./DlvD.vue?vue&type=script&lang=js"
export * from "./DlvD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports